<template>
    <div class="page-center content-load fadeIn animated">
       <!--  <span class="selo">
            <i class="material-icons">check_circle</i>
            Você está em um ambiente seguro.
        </span> -->
        <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide>
                <div class="swiper-layer"></div>
                <center>
                    <img src="static/config/logo.png" class="logo-sidebar" style="width: 100%; margin-top: -6rem;">
                </center>
                <p>
                    Olá! Como deseja entrar?
                </p>
                <br>

                <router-link :to="{'name': 'Login'}" class="button color-secondary" style="bottom: 190px;">
                    <i class="las la-user"></i>
                    Fazer login
                </router-link>
                <router-link :to="{'name': 'Cadastro'}" class="button color-primary" style="bottom: 130px;">
                    <i class="las la-plus"></i>
                    Cadastrar
                </router-link>                    
                <router-link :to="{'name': 'Dashboard'}" class="button " style="bottom: 70px; background: #FFF !important; color: #333 !important">
                    Prosseguir sem cadastro
                    <i class="las la-angle-right"></i>
                </router-link>
            </swiper-slide>            
            <!-- <div class="swiper-pagination" slot="pagination"></div> -->
        </swiper>                                                       

    </div>      
</template>

<script>
export default {
    name: 'Intro',
    data () {
        return {
            swiperOptions: {
                pagination: {
                    el: '.swiper-pagination'
                }
            },
            etapa:      0,            
        }
    },
    methods: {
        next: function() {
            var self = this;
            console.log("next()");
            self.etapa++;
            self.$refs.mySwiper.swiper.slideNext()
            
        },
        prosseguir: function() {
            var self = this;

        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        }
    },
    created() {
        loading.show();
    },
    mounted() {
        var self = this
        
        window.localStorage.setItem("_intro", true);
        setTimeout(function() {
            loading.hide();
        }, 100);
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .swiper-container {
      width: 100%;
      height: 100%;
    }

    .swiper-slide {
      text-align: center;
      font-size: 18px;
      background: #fff;

      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
    }    
    .current-page-introducao .loading {
        top: 0px !important;
    }
    .page-introducao #wrapper {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }
    .page-introducao .container {
        padding-left: 20px;
        padding-right: 20px;
    }
    .logo {
        width: 80%;
        margin-bottom: 5vh;
    }
    .page-introducao p {
        z-index: 2;
        color: #333;
        font-size: 1.2em;
        line-height: 130%;
        padding-left: 10%;
        padding-right: 10%;
    }
    .page-introducao .button i {


    }
    .page-introducao .button {
        position: absolute;
        bottom: 50px;
        top: auto;
        /*border: none;*/
        border-color: var(--theme-color-primary);
        background: var(--theme-color-primary);
        color: #FFF;
        left: 40px;
        right: 40px;
        width: auto;
        /*width: 80%;*/
    }
/*    .page-introducao .swiper-container {
        height: 100vh;
        background-image: url(static/images/img1.jpg);
        background-position: 60%;
        background-size: cover;
        background-repeat: no-repeat;
    }*/
    .page-introducao .swiper-slide {
        flex-direction: column;
        background: transparent;
    }
    .page-introducao .swiper-layer {
        position: absolute;
        left: 0px;
        right: 0px;
        z-index: 0;
        top: 0px;
        bottom: 0px;
        background: #FFF;
        opacity: 0.93;
    }
    .page-introducao .logo, .page-introducao center {
        z-index: 1;
    }
    .page-introducao .swiper-pagination-bullet-active {
        background: var(--theme-color-primary) !important;
    }

    .page-introducao #wrapper {
        display: block !important;
    }

    .page-introducao .selo {
        /*position: absolute;*/
        top: 5px;
        width: 100%;
        position: fixed;
        line-height: 100%;
        z-index: 999;
        display: block;
        margin-top: 5px;
        text-transform: uppercase;
        font-size: 10px;
        text-align: center;
        letter-spacing: 0px;
        color: #444;
        opacity: 0.6;
    }
    .page-introducao .selo i {
        font-size: 14px;
        top: 2px;
        color: var(--theme-color-primary);
        position: relative;
    }    
    /*.button {
        border-color: inherit;
    } */
</style>



// WEBPACK FOOTER //
// src/components/Intro.vue